<template>
    <button :disabled="loading" @click="clicked" class="px-6 py-2">
        <spinner v-if="loading" />
        <span v-else>{{ label }}</span>
    </button>
</template>
<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: 'Button',
        },
    },
    methods: {
        clicked() {
            this.$emit('click')
        },
    },
}
</script>
